var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5042 18.75H19.9997C20.5532 18.75 21.002 18.4142 21.002 18C21.002 17.5858 20.5532 17.25 19.9997 17.25H10.5042C9.9507 17.25 9.50195 17.5858 9.50195 18C9.50195 18.4142 9.9507 18.75 10.5042 18.75Z",
    fill: "#01AB6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95 18.75H5.55C6.07467 18.75 6.5 18.4142 6.5 18C6.5 17.5858 6.07467 17.25 5.55 17.25H1.95C1.42533 17.25 1 17.5858 1 18C1 18.4142 1.42533 18.75 1.95 18.75Z",
    fill: "#01AB6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99805 18C4.99805 19.6569 6.34119 21 7.99805 21C9.6549 21 10.998 19.6569 10.998 18C10.998 16.3431 9.6549 15 7.99805 15C6.34119 15 4.99805 16.3431 4.99805 18ZM9.49698 18C9.49698 18.8284 8.82541 19.5 7.99698 19.5C7.16855 19.5 6.49698 18.8284 6.49698 18C6.49698 17.1716 7.16855 16.5 7.99698 16.5C8.82541 16.5 9.49698 17.1716 9.49698 18Z",
    fill: "#01AB6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5719 11.6855L2.07651 11.6855C1.52296 11.6855 1.07422 12.0213 1.07422 12.4355C1.07422 12.8498 1.52296 13.1855 2.07651 13.1855L11.5719 13.1855C12.1255 13.1855 12.5742 12.8498 12.5742 12.4355C12.5742 12.0213 12.1255 11.6855 11.5719 11.6855Z",
    fill: "#01AB6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1262 11.6855H16.5262C16.0015 11.6855 15.5762 12.0213 15.5762 12.4355C15.5762 12.8498 16.0015 13.1855 16.5262 13.1855H20.1262C20.6508 13.1855 21.0762 12.8498 21.0762 12.4355C21.0762 12.0213 20.6508 11.6855 20.1262 11.6855Z",
    fill: "#01AB6C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0781 12.4355C17.0781 10.7787 15.735 9.43555 14.0781 9.43555C12.4213 9.43555 11.0781 10.7787 11.0781 12.4355C11.0781 14.0924 12.4213 15.4355 14.0781 15.4355C15.735 15.4355 17.0781 14.0924 17.0781 12.4355ZM12.5792 12.4355C12.5792 11.6071 13.2508 10.9355 14.0792 10.9355C14.9076 10.9355 15.5792 11.6071 15.5792 12.4355C15.5792 13.264 14.9076 13.9355 14.0792 13.9355C13.2508 13.9355 12.5792 13.264 12.5792 12.4355Z",
    fill: "#01AB6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5042 7.75H19.9997C20.5532 7.75 21.002 7.41421 21.002 7C21.002 6.58579 20.5532 6.25 19.9997 6.25H10.5042C9.9507 6.25 9.50195 6.58579 9.50195 7C9.50195 7.41421 9.9507 7.75 10.5042 7.75Z",
    fill: "#01AB6C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95 7.75H5.55C6.07467 7.75 6.5 7.41421 6.5 7C6.5 6.58579 6.07467 6.25 5.55 6.25H1.95C1.42533 6.25 1 6.58579 1 7C1 7.41421 1.42533 7.75 1.95 7.75Z",
    fill: "#01AB6C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99805 7C4.99805 8.65685 6.34119 10 7.99805 10C9.6549 10 10.998 8.65685 10.998 7C10.998 5.34315 9.6549 4 7.99805 4C6.34119 4 4.99805 5.34315 4.99805 7ZM9.49698 7C9.49698 7.82843 8.82541 8.5 7.99698 8.5C7.16855 8.5 6.49698 7.82843 6.49698 7C6.49698 6.17157 7.16855 5.5 7.99698 5.5C8.82541 5.5 9.49698 6.17157 9.49698 7Z",
    fill: "#01AB6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.97cd47d061d734852b161e9af5b19666.svg";
export { ForwardRef as ReactComponent };